import { createSlice } from "@reduxjs/toolkit";
import { TodoCategoryCode, TodoTaskCategoryList } from "../../entity/Entity";

type TD001Slice = {
  todoCategoryList: TodoTaskCategoryList
};

export const initialState: TD001Slice = {
  todoCategoryList: []
};

export const TodoTaskWorkflow = createSlice({
  name: "todoTaskWorkflow",
  initialState,
  reducers: {
    setTodoCategoryList: (state, action) => {
      const initCategory = {
        "id": -1,
        "code": "todo_task_all" as TodoCategoryCode,
        "description": "全てのタスク",
        "createdAt": null,
        "updatedAt": null,
        "count": action.payload.total
      }
      // state.todoCategoryList = [initCategory, ...action.payload.todoCategoryList]
      state.todoCategoryList = [initCategory]
    }
  },
});

export const {
  setTodoCategoryList
} = TodoTaskWorkflow.actions;

export default TodoTaskWorkflow.reducer;
